import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Loaded: arm by feeding a die ≤3; on
 * the opponent's next attack, reflect 50% of the damage raw to the attacker,
 * then disarm. */
export const CALTROPS: Card = {
  id: 'caltrops',
  name: 'Caltrops',
  type: 'trap',
  rarity: 'common',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'max', value: 3 }],
  effects: [{ kind: 'reflectDamage', fraction: 0.5 }],
  trap: { variant: 'loaded', trigger: { kind: 'opponentAttacks' } },
};
